module.exports = __webpack_public_path__ + "static/cannon-3bc220f7c7d7222fa113ef244f5a0277.png";